import { PriceListPickerDirectiveModule } from '@b2b/common/directives/priceListPicker/priceListPicker.directive';
import { ApiService } from '@b2b/common/services/api/types';
import { TODO } from '@b2b/types/core';
import uiRouter, { IInjectable, StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { ProgramsCombosCreateConfigureControllerModule } from './controllers/ProgramsCombosCreateConfigureController';
import { ThemesDataResolver } from '@b2b/common/resolvers';

function EventTemplatesDataResolver(): IInjectable {
  return [
    'ApiService',
    'HelpersService',
    function (apiService: ApiService, helpersService: TODO) {
      return apiService.program.names(false, helpersService.getPaginator());
    },
  ];
}

function AddonsDataResolver(): IInjectable {
  return [
    'ApiService',
    'HelpersService',
    function (apiService: ApiService, helpersService: TODO) {
      return apiService.inventory.list(angular.extend({ addonTypes: 'doNotTrack' }, helpersService.getPaginator()));
    },
  ];
}

export const ProgramsCombosCreateConfigureView = angular
  .module('acme.view.application.programs.combos.create.configure', [
    uiRouter,
    'ui.bootstrap',
    ProgramsCombosCreateConfigureControllerModule,
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.directive.integer',
    'acme.common.directive.numeric',
    PriceListPickerDirectiveModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.programs.combos.create.configure',
      url: '/configure',
      views: {
        'subview-main': {
          controller: 'ProgramsCombosCreateConfigureController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/programs/combos/create/configure/configure.tpl.html',
        },
      },
      data: {
        pageTitle: 'Create Combo Details',
      },
      resolve: {
        ThemesData: ThemesDataResolver({ includeEmail: true }),
        EventTemplatesData: EventTemplatesDataResolver(),
        AddonsData: AddonsDataResolver(),
      },
    });

    $stateProvider.state({
      name: 'application.programs.combos.edit.configure',
      url: '/configure',
      views: {
        'subview-main': {
          controller: 'ProgramsCombosCreateConfigureController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/programs/combos/create/configure/configure.tpl.html',
        },
      },
      data: {
        pageTitle: 'Edit Combo Details',
      },
      resolve: {
        ThemesData: ThemesDataResolver({ includeEmail: true }),
        EventTemplatesData: EventTemplatesDataResolver(),
        AddonsData: AddonsDataResolver(),
      },
    });
  }).name;
